import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import SpeakerAssignmentChoiceButton from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/InterviewDetails/SpeakerAssignmentSidebar/SpeakerAssignmentChoices/SpeakerAssignmentChoiceButton';
import useAssignTranscriptSpeaker from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/InterviewDetails/SpeakerAssignmentSidebar/Hooks/useAssignTranscriptSpeaker';
import * as React from 'react';

type Props = {
	readonly facilityId: number;
	readonly subject: SubjectAddress;
	readonly interviewId: number;
	readonly speakerId: number;
	readonly selected: boolean;
	/** Non-`null` when a DIFFERENT speaker of this transcript already carries `kind = beneficiary`. */
	readonly disabledReason: string | null;
};

/**
 * Only one speaker may be the accompanied person (§5.5): the front already holds the full speaker
 * list, so this choice disables itself with the server's own rule rather than letting the click
 * through to a `422`.
 */
const SpeakerAssignmentBeneficiaryChoice: React.FC<Props> = ({
	facilityId,
	subject,
	interviewId,
	speakerId,
	selected,
	disabledReason,
}) => {
	const assign = useAssignTranscriptSpeaker(facilityId, subject, interviewId, speakerId);

	const handleClick = React.useCallback(() => {
		assign('beneficiary', null, null, null);
	}, [assign]);

	return (
		<SpeakerAssignmentChoiceButton
			label="La personne accompagnée"
			selected={selected}
			disabledReason={disabledReason}
			onClick={handleClick}
		/>
	);
};

export default SpeakerAssignmentBeneficiaryChoice;
